/** Is there a live session in this tab? Read without redirecting — the landing must never
 * bounce a stranger to the hosted login (that is the Sign in link's job). */
import { createUserManager, sessionFrom } from "../auth/session";
import type { AppConfig } from "../config";

export async function hasSession(cfg: AppConfig): Promise<boolean> {
  try {
    const user = await createUserManager(cfg, window.location.origin).getUser();
    return sessionFrom(user) !== null;
  } catch {
    return false;
  }
}
